/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=0300eb14"
const script = {}

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__